import { Component, OnInit, Input, ViewChild, Renderer2 } from '@angular/core';
import { ELearningDashboardClass, ELearningDashboardStudent, ELearningDashboardState } from '../../Elearning-Models';
import { IServiceFactory } from '../../Services/service-factory';
import { FilterService } from '../../Services/filter-service';
import { MatMenu } from '@angular/material/menu';
import { IStateService } from '../../Services/state-service';

@Component({
  selector: 'app-elearningdash-class-view',
  templateUrl: './elearningdash-class-view.component.html',
  styleUrls: ['./elearningdash-class-view.component.scss']
})
export class ElearningdashClassViewComponent implements OnInit {

@Input() classData: ELearningDashboardClass;
@ViewChild('menu', {static: true}) menu: MatMenu;
  constructor(private serviceFactory: IServiceFactory, private _renderer2: Renderer2) { }

  stateService: IStateService;
  filterService: FilterService;

  filter: any;
  studentsShown: ELearningDashboardStudent[];

  state: ELearningDashboardState = new ELearningDashboardState();

  public showClass: boolean = true;
  public hasFilterAndCurrWithAssignments : boolean = false;


  ngOnInit(): void {
    this.setStateService();

    this.setFilterService();

    this.initializeHTMLBooleans();

    }

    private initializeHTMLBooleans(){
      this.hasFilterAndCurrWithAssignments = this.hasFilterAndCurriculumWithAssignments();
    }

  
  private setFilterService() {
    this.filterService = this.serviceFactory.getFilterService();
    this.filterService.studentFilter.subscribe(result => {
      this.setFilterFromService(result);
    });
    this.setFilterFromEmit();

    this.filterService.collapseExpandEmitter.subscribe(result => {
      if(result){
        this.showClass = false;
      }
      else{
        this.showClass = true;
      }
    });
  }

  private setStateService() {
    this.stateService = this.serviceFactory.getStateService();
    this.stateService.stateEmitter.subscribe(result=>{
      if(result){
        this.state.copyFromModel(result);
        this.showClass = !this.state.Collapsed.includes(this.classData.ID);
      }
    });
  }

  saveState(){
    this.stateService.setState(null, null, window.scrollY, null);
    this.stateService.saveState();
  }

  private setFilterFromEmit() {
    this.filterService.emitActiveFilter();
  }

  private setFilterFromService(result: any) {
    this.filter = result;
    this.getStudents()
  }

  //// FILTERS ////
  getStudents()
  {
    this.studentsShown = this.filter(this.classData.Students);
    return this.studentsShown;
  }

  hasFilterAndCurriculumWithAssignments(){
    if(this.classData.CurriculumID == null){
      return false;
    }

    if(this.classData.NoLessonsYet){
      return false;
    }

    if(this.hasNoAssignments()){
      return false;
    }
    
    if(!this.filter){
      this.setFilterFromEmit();
      return false;
    }
    return true;
  }

  /////////////////// HTML /////////////////////////
  hideShowClass(){
    if(this.showClass)
    { // Hide class 
      this.showClass = false;
    }
    else
    { // Show class
      this.showClass = true;
    }
    this.stateService.setState(null, this.classData.ID);
  }

  hasCurriculumButNoAssignments(){
    if(this.classData.CurriculumID && this.hasNoAssignments()){
      return true;
    }
    else{
      return false;
    }
  }

  hasNoAssignments(){
    if(false){
      // need to add something to model that shows the class has no assignments yet
      return true;
    }
    else{
      return false;
    }
  }

  changeBackgroundColor(){
    const el = document.getElementById(this.menu.panelId);
    this._renderer2.setStyle(el, 'background', '#eeeeee');
    this._renderer2.setStyle(el, 'border', '1px solid darkgray');
  }

  studentsWithActionItems(students: ELearningDashboardStudent[]){
    let count = 0;

    students.forEach(student => {
        if(student.NeedsAssignment || student.NeedsGradeReleasedCount > 0 || student.NeedsGradingCount > 0){
          count++;
        }
    });

    return count;
  }

  studentActionItemTooltip(students: ELearningDashboardStudent[]){
    let count = this.studentsWithActionItems(students);
    return count == 1 ? count.toString() + " student requires action" : count.toString() + " students require action";
  }
}
